module.exports = __webpack_public_path__ + "media/categories/1106-3e51cde4.svg";